// frontend/src/components/pages/org/EditEmployeeModal.jsx
import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { updateUser } from "../../../api/apiFunction/userServices";
import { toast } from "react-toastify";

const EditEmployeeModal = ({ isOpen, employee, onClose, onUpdate }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    if (employee) {
      setName(employee.name || "");
      setChanged(false);
    }
  }, [employee]);

  const handleChange = (e) => {
    setName(e.target.value);
    setChanged(e.target.value !== (employee.name || ""));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateUser(employee._id, { name });
      toast.success("Employee updated successfully");
      if (onUpdate) onUpdate();
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to update employee");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !employee) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-bg-60 rounded-lg shadow-lg p-6 w-full max-w-md max-h-[90vh] overflow-y-auto relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-fg-60 hover:text-fg-50"
          aria-label="Close"
        >
          <X size={22} />
        </button>
        <h3 className="text-lg font-semibold mb-6">Employee Information</h3>
        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="block text-sm font-medium text-fg-50 mb-1">Name</label>
            <input
              type="text"
              name="name"
              className="w-full py-2 px-3 rounded-md bg-bg-50 text-fg-50 border border-bd-50 focus:outline-none focus:ring-1 focus:ring-ac-02"
              value={name}
              onChange={handleChange}
              disabled={loading}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-fg-50 mb-1">Email</label>
            <input
              type="email"
              className="w-full py-2 px-3 rounded-md bg-bg-50 text-fg-50 border border-bd-50 cursor-not-allowed"
              value={employee.email || ""}
              disabled
              readOnly
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-fg-50 mb-1">Role</label>
            <input
              type="text"
              className="w-full py-2 px-3 rounded-md bg-bg-50/50 text-fg-50 border border-bd-50 cursor-not-allowed"
              value="Employee"
              disabled
              readOnly
            />
          </div>
          <div className="flex justify-end mt-6 space-x-3">
            <button
              type="button"
              className="py-2 px-4 border border-bd-50 rounded-md text-fg-50 hover:bg-bg-50 transition-colors"
              onClick={onClose}
              disabled={loading}
            >
              Close
            </button>
            <button
              type="submit"
              className={`py-2 px-4 bg-ac-02 text-white dark:text-black rounded-md transition-colors shadow-sm border border-ac-02 flex items-center justify-center ${(!changed || loading) ? 'opacity-60 cursor-not-allowed' : ''}`}
              disabled={!changed || loading}
            >
              {loading ? (
                <span className="animate-spin mr-2">⏳</span>
              ) : null}
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEmployeeModal; 